"use client";

import React, { ReactNode } from "react";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

dayjs.locale("pt-BR");

interface IProps {
	children: ReactNode;
}

interface IContext {
	isLoading?: boolean;
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const HelperContext = React.createContext<IContext | null>(null);

const HelperContextProvider = ({ children }: IProps) => {
	const [isLoading, setIsLoading] = React.useState(false);

	return (
		<HelperContext.Provider
			value={{
				isLoading,
				setIsLoading,
			}}
		>
			{children}
		</HelperContext.Provider>
	);
};

const useHelperContext = () => {
	const context = React.useContext(HelperContext);

	return context as IContext;
};

export { HelperContext, useHelperContext, HelperContextProvider };
